import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { conversationsApi, type ConversationConfig } from '../lib/api/domains/conversations.js';
import type { SupportedBotName } from '@discord-bot-platform/service-client';

export const conversationConfigKeys = {
  all: ['conversationConfig'] as const,
  config: (guildId: string, botName: SupportedBotName) => [...conversationConfigKeys.all, guildId, botName] as const,
};

export const useConversationConfig = (guildId: string, botName: SupportedBotName, enabled = true) => {
  return useQuery({
    queryKey: conversationConfigKeys.config(guildId, botName),
    queryFn: () => conversationsApi.getConfig(guildId, botName),
    enabled: enabled && !!guildId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};

export const useConversationConfigUpdate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: { guildId: string; botName: SupportedBotName; config: Partial<ConversationConfig> }) =>
      conversationsApi.updateConfig(params.guildId, params.botName, params.config),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: conversationConfigKeys.config(variables.guildId, variables.botName) });
    },
  });
};
